import { createAsyncAction } from 'redux-promise-middleware-actions';
import dayjs from 'dayjs';
import { addAsyncActionPostfixes } from '../utils/actionTypeCreator';
import { tneAxiosClient } from '../api/apiSettings';
import { months } from '../utils/constants';

export const types = {
  ...addAsyncActionPostfixes({
    GET_TIMESHEETS: 'GET_TIMESHEETS',
    GET_NEXT_TIMESHEETS: 'GET_NEXT_TIMESHEETS',
    DELETE_TIMESHEET: 'DELETE_TIMESHEET'
  })
};

let abortController;

const handleAbort = () => {
  if (abortController) {
    abortController.abort();
  }

  abortController = new AbortController();
};

const commonGetTimesheetsRequest = (
  id,
  pageNumber,
  pageSize,
  start,
  month,
  year,
  location,
  status,
  contractor,
  t,
  isApprover,
  filtersOptions
) => {
  const getMonthIndex = (mon) => {
    let index;
    months(t).forEach((element, i) => {
      if (element === mon) index = i + 1;
    });
    return index;
  };

  let basicUrl = `v1/${
    isApprover ? 'get-timesheets-by-approverId' : 'timesheet/dashboard'
  }?userId=${id}&PageNumber=${pageNumber}
    &PageSize=${pageSize}&StartDate=${start}&EndDate=${start ? dayjs(start).add(6, 'day').format('DD-MMM-YYYY') : ''}`;
  if (location && location !== t('common.general.all')) basicUrl += `&Location=${location}`;
  if (status && status !== t('common.general.all')) basicUrl += `&Status=${status}`;
  if (contractor?.FirstName && contractor?.LastName && contractor !== t('common.general.all'))
    basicUrl += `&FirstName=${contractor.FirstName}&LastName=${contractor.LastName}`;
  if (month && month !== t('common.general.all')) basicUrl += `&Month=${getMonthIndex(month)}`;
  if (year && year !== t('common.general.all')) basicUrl += `&Year=${year}`;
  if (month && !year) basicUrl += `&Year=${filtersOptions.Years.at(-1).Year}`;

  handleAbort();

  return tneAxiosClient.get(basicUrl, { signal: abortController.signal }).then((res) => res?.data);
};

export const getTimesheets = createAsyncAction(types.GET_TIMESHEETS, commonGetTimesheetsRequest);

export const getNextTimesheets = createAsyncAction(types.GET_NEXT_TIMESHEETS, commonGetTimesheetsRequest);

export const deleteTimesheet = createAsyncAction(types.DELETE_TIMESHEET, (id) => {
  return tneAxiosClient.delete(`v1/timesheet?timesheetId=${id}`).then(() => id);
});
